import { createFileRoute } from '@tanstack/react-router'

import DetailGapoktanPage from '@/components/pages/backoffice/_klb-petani/_gapoktan/_$gapoktanId/containers/DetailGapoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/gapoktan/$gapoktanId/'
)({
  component: DetailGapoktanPage
})
